import React, { ReactNode } from 'react';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import * as iconsList from '@vio/atlas-assets';
import { getLinariaClassName } from '../../../utils/getLinariaClassName';
import { Icon, IconSize } from '../Icon';
export const BADGE_VARIANTS = ['info', 'neutral', 'success', 'warning', 'danger'] as const;
export const BADGE_SIZES = ['xs', 'sm', 'md'] as const;
export type BadgeVariant = (typeof BADGE_VARIANTS)[number];
export type BadgeSize = (typeof BADGE_SIZES)[number];
interface Props {
  /** Content to be displayed in the Badge */
  children?: ReactNode;
  /** Pass through classname to allow styles overrides */
  className?: string;
  /** Icon used instead of children font */
  iconName?: keyof typeof iconsList;
  /** The size of the component */
  size?: BadgeSize;
  /** The variation of styling the component will have */
  variant?: BadgeVariant;
}
interface StyleProps {
  iconName: Props['iconName'];
  size: BadgeSize;
  variant: BadgeVariant;
}
interface SizeMapItem {
  iconSize: IconSize;
  iconPadding: number;
  size: number;
}
const sizeMap: Record<string, SizeMapItem> = {
  xs: {
    iconSize: 'xs',
    iconPadding: 2,
    size: 16
  },
  sm: {
    iconSize: 'sm',
    iconPadding: 2,
    size: 20
  },
  md: {
    iconSize: 'sm',
    iconPadding: 4,
    size: 24
  }
};
export const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "wy3s2v6",
  propsAsIs: false
});
export const Badge = ({
  children,
  iconName,
  size = 'xs',
  variant = 'info',
  className
}: Props) => <Wrapper iconName={iconName} size={size} variant={variant} className={cx(`${getLinariaClassName(Wrapper)}--variant-${variant}`, `${getLinariaClassName(Wrapper)}--size-${size}`, iconName && 'withIcon', className)}>
    {iconName ? <Icon name={iconName} size={sizeMap[size].iconSize} /> : children}
  </Wrapper>;

require("./Badge.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./Badge.tsx");